<!-- <div class="footer_section">
  <div class="container">
    <div class="row">
      <div class="col-lg">
        <div class="foot-cont">
          <a><img src="../../../assets/images/logo.png" alt="" /></a>
          <h4>{{'Who We Are'|translate}}</h4>
          <p>
            Gmmco was established in 1967 as part of the illustrious CK Birla Group, an USD 2.4 billion conglomerate,
            and has its headquarters in Chennai. Since inception, we have been consistently pushing boundaries to become
            a leading player in the infrastructure, construction and mining sectors in the country with world-class
            engineering capability.
          </p>
        </div>
      </div>
      <div class="col-lg">
        <div class="foot-cont foot-cont-cen">

          <ul>
            <li>
              <h4>{{'Who We Are'|translate}}</h4>
            </li>
            <li><a>{{'Order Parts'|translate}}</a></li>
            <li><a>{{'My Fleets'|translate}}</a></li>
            <li><a>{{'My Plan'|translate}}</a></li>
            <li><a>{{'Assistant'|translate}}</a></li>
            <li><a>{{'My Quotes'|translate}}</a></li>
          </ul>
        </div>
      </div>
      <div class="col-lg">
        <div class="foot-cont ">
          <h4>{{'Happy to Help you'|translate}}</h4>
          <ul>
            <li><a href="mailto:contact@samplemail.com">
                <b><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M17.8741 4.06342H16.2488V1.56579C16.2488 1.18924 16.0009 0.941406 15.6244 0.941406H3.75116C3.37461 0.941406 3.12674 1.18924 3.12674 1.56579V4.06342H2.12581C0.815037 4.06342 0 4.74978 0 5.87466V16.623C0 17.7478 0.93903 19.0586 2.12585 19.0586H17.8741C19.1229 19.0586 20 17.7478 20 16.623V5.87466C20 4.74978 19.1229 4.06342 17.8741 4.06342ZM16.2488 5.31222H17.2831L16.2488 6.12726V5.31222ZM4.37562 2.19021H15V7.11393L10.6244 10.5649L9.93806 11.1273L4.37562 6.81842V2.19021ZM3.12678 5.31222V5.8508L2.43566 5.31222H3.12678ZM1.25356 16.623V5.97476L7.78835 11.0128L1.25356 16.6802C1.25356 16.6611 1.25356 16.6421 1.25356 16.623ZM17.879 17.8097L2.12585 17.8098C2.04958 17.8098 1.97331 17.7907 1.90184 17.7574L8.78936 11.7898L9.19477 12.1373C9.62158 12.5032 10.2522 12.5005 10.6759 12.1309L11.1106 11.7516L18.0077 17.7859C17.9648 17.8002 17.9219 17.8097 17.879 17.8097ZM18.7512 16.6277C18.7512 16.6801 18.7464 16.7326 18.7369 16.7898L12.0972 10.9748L18.7416 5.75551C18.7512 5.80792 18.7512 5.85084 18.7512 5.87943V16.6277Z"
                      fill="white" />
                  </svg></b>
                contact@samplemail.com</a></li>
            <li><a href="tel:18001800043">
                <b><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M17.1013 2.61997C15.4116 0.930342 13.1651 -9.45014e-05 10.7757 7.19903e-09C10.3842 7.19903e-09 10.0669 0.31736 10.0669 0.708814C10.0669 1.10027 10.3843 1.41763 10.7757 1.41763C12.7865 1.41753 14.6769 2.20054 16.0988 3.62242C17.5208 5.0443 18.3038 6.93485 18.3037 8.94571C18.3037 9.33716 18.621 9.65452 19.0125 9.65452C19.404 9.65452 19.7213 9.33716 19.7213 8.9458C19.7214 6.55615 18.791 4.30959 17.1013 2.61997Z"
                      fill="white" />
                    <path
                      d="M14.1855 8.94572C14.1855 9.33717 14.5028 9.65453 14.8944 9.65444C15.2858 9.65444 15.6031 9.33708 15.6031 8.94562C15.6029 6.28426 13.4374 4.11879 10.7758 4.11841C10.7757 4.11841 10.7758 4.11841 10.7757 4.11841C10.3843 4.11841 10.067 4.43567 10.0669 4.82713C10.0669 5.21858 10.3842 5.53594 10.7756 5.53604C12.6557 5.53632 14.1853 7.06585 14.1855 8.94572Z"
                      fill="white" />
                    <path
                      d="M12.617 12.5598C11.5366 12.5039 10.9862 13.3074 10.7222 13.6934C10.5011 14.0165 10.5839 14.4576 10.9071 14.6786C11.2302 14.8997 11.6713 14.8169 11.8923 14.4938C12.2042 14.0378 12.3455 13.966 12.5371 13.9751C13.1506 14.0472 15.5667 15.8177 15.8086 16.3714C15.8693 16.5344 15.8671 16.6942 15.8019 16.8886C15.5483 17.6415 15.1284 18.1705 14.5874 18.4185C14.0735 18.6541 13.4434 18.6328 12.7657 18.357C10.235 17.3255 8.02407 15.8861 6.19438 14.0785C6.19363 14.0777 6.19287 14.0771 6.19221 14.0763C4.38842 12.2484 2.95161 10.0403 1.92184 7.51355C1.64597 6.83526 1.62461 6.20508 1.86022 5.69124C2.10821 5.15027 2.63727 4.73037 3.38946 4.47699C3.58453 4.41159 3.74406 4.40951 3.90558 4.46962C4.46119 4.71241 6.23162 7.12843 6.30307 7.73499C6.31328 7.93383 6.24098 8.07503 5.78535 8.38634C5.46213 8.60711 5.37906 9.04818 5.59993 9.3714C5.8207 9.69462 6.26168 9.7776 6.58499 9.55683C6.97115 9.29315 7.77447 8.74424 7.71871 7.66014C7.65728 6.52773 5.45448 3.52888 4.40193 3.14187C3.93383 2.96741 3.44144 2.96438 2.9379 3.13336C1.80493 3.5149 0.986678 4.19517 0.571596 5.10056C0.16899 5.97892 0.181748 6.99801 0.608927 8.04819C1.71099 10.7523 3.2529 13.1183 5.19174 15.0808C5.19647 15.0856 5.20129 15.0903 5.2062 15.0949C7.16726 17.0302 9.53054 18.5693 12.231 19.67C12.7718 19.8899 13.3044 20 13.8137 20C14.2932 20 14.7523 19.9025 15.1782 19.7072C16.0837 19.2923 16.7638 18.4741 17.1457 17.3404C17.3143 16.8378 17.3115 16.3456 17.1384 15.8796C16.75 14.8243 13.7512 12.6215 12.617 12.5598Z"
                      fill="white" />
                  </svg></b>
                Toll Free No: 18001800043</a></li>
          </ul>
        </div>
        <div class="foot-cont">
          <h4>{{'Follow Us On'|translate}}</h4>
          <ul class="list-inline mt-1">
            <li class="list-inline-item"><a href="#"><i class="fab fa-facebook-f"></i></a></li>
            <li class="list-inline-item"><a href="#"><i class="fab fa-twitter"></i></a></li>
            <li class="list-inline-item"><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
            <li class="list-inline-item"><a href="#"><i class="fab fa-google-plus-g"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</div> -->
<div class="main-footer">
  <div class="footer-sub-part">
    <div class="contact-left">
      <p>Contact Us:</p>
      <span><a href="tel:18004252546">18004252546</a></span>
      <span><a href="https://www.gmmco.in/gmmco-cat/" target="_blank">www.gmmco.in</a></span>
    </div>

    <div class="copy-right">
      <ul class="footer_ul">
        <li><a href="{{envVar.baseUrl}}RegHelp/Privacy%20Policy%20for%20GmmcoAssist.pdf" target="_blank">Privacy
            Policy</a> </li>
        <li><a href="{{envVar.baseUrl}}RegHelp/Cancellation%20Return%20Replacement%20Terms.pdf" target="_blank">Return
            Policy </a> </li>
        <li><a href="{{envVar.baseUrl}}RegHelp/Customer%20App%20FAQ.pdf" target="_blank">FAQ</a></li>
      </ul>
      <p class="copy-rgt">Ⓒ 2021 GMMCO Limited. All rights reserved.</p>
    </div>
    <!-- <div class="foot-cont">
  <h4>{{'Follow Us On'|translate}}</h4>
  <ul class="list-inline mt-1">
    <li class="list-inline-item"><a href="https://www.facebook.com/gmmcoindia" target="_blank" ><i class="fab fa-facebook-f"></i></a></li>
       <li class="list-inline-item"><a href="https://twitter.com/gmmco_cat" target="_blank" ><i class="fab fa-twitter"></i></a></li>
    <li class="list-inline-item"><a href="https://www.linkedin.com/company/gmmco-ltd" target="_blank" ><i class="fab fa-linkedin-in"></i></a></li>
    <li class="list-inline-item"><a href="https://www.youtube.com/channel/UCN7EyeQ1qjmft1Jc2GtH7xw" target="_blank" ><i class="fab fa-google-plus-g"></i></a></li>
    <li class="list-inline-item"><a href="https://www.gmmco.in/gmmco-cat/" target="_blank" > <i class="fas fa-globe"></i></a></li>

  </ul>
</div> -->
  </div>
</div>